import { TranslationsContext } from '@teliaee/telia-translate';
import { format, parseISO } from 'date-fns';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Notice, Separator, Text } from 'telia-front-react';
import { useStores } from '../stores/RootStore';

const ReservationSuccess = observer((): React.JSX.Element => {
  const {
    reservationStore: {
      reservationCreation: { time },
      selectedBranchName,
      requireTechnician
    },
    countryCallingCodeStore: { isForeignCodeSelected }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Notice type="success">
        <h5>{translate('reservation.thankYou')}</h5>
        <Separator spacing="xxsmall" color="invisible" />
        <p>
          {translate('reservation.appointment.description', {
            store: selectedBranchName,
            date: format(parseISO(time), 'dd.MM.yyyy'),
            time: format(parseISO(time), 'HH.mm')
          })}
        </p>
      </Notice>
      <Separator spacing="small" color="invisible" />
      <Text>
        <div>
          <p>{translate(`reservation.${isForeignCodeSelected ? 'email' : 'sms'}.description`)}</p>
          <Separator spacing="xsmall" color="invisible" />
          <strong>
            <h5>{translate(`reservation.uponArrival${requireTechnician ? '.techStoreVisit' : ''}${isForeignCodeSelected ? '.email' : ''}`)}</h5>
            <Separator spacing="xsmall" color="invisible" />
            {translate(`reservation.cancel${isForeignCodeSelected ? '.email' : ''}.description`)}
          </strong>
        </div>
      </Text>
    </>
  );
});

export default ReservationSuccess;
